import { useEffect, useState } from "react";

/**
 * `/reset` — emergency escape hatch. Wipes ALL local state (localStorage,
 * sessionStorage, IndexedDB, Cache Storage, Service Worker) and hard-reloads.
 * Used when a stuck bundle traps the user (e.g. legacy `casaneo_view_mode`
 * left them in owner-preview and the yellow banner isn't clickable).
 * No auth required — safe to hit from a fresh browser.
 */
export default function Reset() {
  const [status, setStatus] = useState("Nettoyage en cours…");

  useEffect(() => {
    (async () => {
      try {
        try { localStorage.clear(); } catch { /* noop */ }
        try { sessionStorage.clear(); } catch { /* noop */ }
        // Kill every cache the SW might have parked.
        try {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        } catch { /* noop */ }
        // Kick every service worker out.
        try {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map((r) => r.unregister()));
        } catch { /* noop */ }
        // Best-effort IndexedDB flush (workbox / auth token DBs).
        try {
          if (indexedDB.databases) {
            const dbs = await indexedDB.databases();
            await Promise.all(
              (dbs || [])
                .map((d) => d.name)
                .filter(Boolean)
                .map(
                  (name) =>
                    new Promise((resolve) => {
                      const req = indexedDB.deleteDatabase(name);
                      req.onsuccess = req.onerror = req.onblocked = () => resolve();
                    })
                )
            );
          }
        } catch { /* noop */ }
        setStatus("Redirection vers l'écran de connexion…");
        setTimeout(() => {
          window.location.replace("/login");
        }, 600);
      } catch (e) {
        setStatus("Nettoyage terminé — rechargez la page manuellement.");
      }
    })();
  }, []);

  return (
    <div
      className="min-h-screen bg-[#071e42] text-slate-100 grid place-items-center px-6"
      data-testid="reset-page"
    >
      <div className="max-w-md text-center">
        <img
          src="/casaneo-logo.jpg"
          alt="Casanéo"
          className="h-14 w-auto rounded-lg mx-auto mb-6"
        />
        <h1 className="font-serif text-3xl text-white">Réinitialisation Casanéo</h1>
        <p className="mt-3 text-slate-300">{status}</p>
        <p className="mt-6 text-xs text-slate-500">
          Ceci vide le cache local (jamais vos données serveur).
        </p>
      </div>
    </div>
  );
}
